import CheckIcon from '@mui/icons-material/Check';
import {Stack, Typography} from '@mui/material';
import {ReactNode} from 'react';
import {
  ActionButton,
  PlanCard as CardRoot,
  FeatureList,
  FeatureRow,
  PlanName,
  PlanStorage,
  PopularBadge,
  Price,
  PriceRow,
  PriceUnit,
} from './client-tariffs.styles';

interface Props {
  name: string;
  storage: string;
  price: string;
  priceUnit?: string;
  features: string[];
  highlighted?: boolean;
  popular?: boolean;
  current?: boolean;
  actionActive?: boolean;
  actionLabel?: string;
  actionIcon?: ReactNode;
  actionDisabled?: boolean;
  onAction?: VoidFunction;
  onSelect?: VoidFunction;
}

export const PlanCard = ({
  name,
  storage,
  price,
  priceUnit = 'месяц',
  features,
  highlighted,
  popular,
  actionActive,
  actionLabel,
  actionIcon,
  actionDisabled,
  onAction,
  onSelect,
}: Props) => {
  return (
    <CardRoot highlighted={highlighted} onClick={onSelect}>
      {popular && <PopularBadge>Популярный тариф</PopularBadge>}
      <Stack width="100%" alignItems="center" gap="6px">
        <PlanName>{name}</PlanName>
        <PlanStorage>{storage}</PlanStorage>
      </Stack>
      <PriceRow>
        <Price>{price}</Price>
        <PriceUnit>/ {priceUnit}</PriceUnit>
      </PriceRow>
      <FeatureList>
        {features.map((feature) => (
          <FeatureRow key={feature}>
            <CheckIcon sx={{color: '#3AC977', fontSize: 20}} />
            <Typography variant="body2">{feature}</Typography>
          </FeatureRow>
        ))}
      </FeatureList>
      <ActionButton
        variant="contained"
        active={actionActive}
        startIcon={actionIcon}
        disabled={actionDisabled}
        onClick={(event) => {
          event.stopPropagation();
          onAction?.();
        }}
      >
        {actionLabel}
      </ActionButton>
    </CardRoot>
  );
};
